import { IAddress, ICoordinates, Project } from "./project.model";

export class Markout {

    _id: string;
    projectId: string;
    ticketNumber: string;
    address: IAddress;
    coordinates: ICoordinates;
    crossStreet1?: string;
    crossStreet2?: string;
    digStartDate?: string;
    startByDate?: string;
    expirationDate?: string;
    reminderDate?: string;
    notes?: string;
    isArchived: boolean;
    isDeleted: boolean;
    incidentsCount: number = 0
    project?: Project | null = null
    status: 'PENDING' | 'ACTIVE' | 'EXPIRING' | 'EXPIRED' | 'ARCHIVED'
    constructor(data: any) {
        this._id = data._id || '';
        this.projectId = data.projectId || '';
        this.ticketNumber = data.ticketNumber || '';
        this.address = data.address || { street: '', city: '', state: '', zipCode: '', country: '' };
        this.coordinates = data.coordinates || { lat: 0, lng: 0 };
        this.crossStreet1 = data.crossStreet1 || '';
        this.crossStreet2 = data.crossStreet2 || '';
        this.digStartDate = data.digStartDate
        this.startByDate = data.startByDate
        this.expirationDate = data.expirationDate
        this.reminderDate = data.reminderDate
        this.notes = data.notes || '';
        this.isArchived = data.isArchived || false;
        this.isDeleted = data.isDeleted || false;
        this.incidentsCount = data.incidentsCount || 0;
        this.project = data.project || null;
        this.status = data.status || null;
    }

    // /**
    //  * Dynamically calculates the status of the markout based on its dates.
    //  */
    // get status(): 'PENDING' | 'ACTIVE' | 'EXPIRING' | 'EXPIRED' | 'ARCHIVED' {
    //     if (this.isArchived || this.isDeleted) {
    //         return 'ARCHIVED';
    //     }

    //     const now = new Date();
    //     now.setHours(0, 0, 0, 0); // Compare dates only, ignore time

    //     if (this.expirationDate && new Date(this.expirationDate) < now) {
    //         return 'EXPIRED';
    //     }

    //     if (this.digStartDate && new Date(this.digStartDate) > now) {
    //         return 'PENDING';
    //     }

    //     // If we are here, it's after the dig start date and before the expiration date.
    //     if (this.digStartDate && new Date(this.digStartDate) <= now) {
    //         if (this.expirationDate) {
    //             const xDaysFromNow = new Date();
    //             xDaysFromNow.setHours(0, 0, 0, 0);
    //             xDaysFromNow.setDate(xDaysFromNow.getDate() + 10);

    //             if (new Date(this.expirationDate) <= xDaysFromNow) {
    //                 return 'EXPIRING';
    //             }
    //         }
    //         return 'ACTIVE';
    //     }

    //     // Fallback status if dates are not properly set
    //     return 'ACTIVE';
    // }

}